<template>
    <div class="news-shortcut-container">
        <div class="left-wrap">
            <div class="common-header-wrap">
                <p class="name">{{ aliasMap.news || '新闻资讯' }}</p>
                <p class="more" @click="goList('information')">更多</p>
            </div>
            <NewsWrap :data="data.newsList" />
        </div>
        <div class="right-wrap">
            <div class="common-header-wrap">
                <p class="name">{{ aliasMap.notice || '通知公告' }}</p>
                <p class="more" @click="goList('notice')">更多</p>
            </div>
            <NoticeWrap :data="data.noticeList" />
        </div>
    </div>
</template>

<script setup>
import NewsWrap from './common-news.vue';
import NoticeWrap from './common-notice.vue';
import { ref, computed, onMounted, reactive, watch } from 'vue';
import { pageJump } from '@/global/location-transfer';
import dayjs from 'dayjs';

import getUserStage from '@/hooks/common/useStageHook';

let { portalTemplate, getStages } = getUserStage();

const props = defineProps({
    alias: {
        type: Array,
        default: () => {
            return [];
        },
    },
});

const aliasMap = computed(() => {
    let temp = {};
    (props.alias || []).forEach(item => {
        temp[item.modelName] = item.aliasName || item.name;
    });
    return temp;
});

let currentTab = ref('information');

// 是否显示更多公告新闻
const isShowMore = computed(() => {
    if (currentTab.value === 'information') {
        let list = data.newsList ?? [];
        return list.length > 0;
    }
    let noticeList = data.noticeList ?? [];
    return noticeList.length > 0;
});

// 跳转新闻或者公告列表页
function goList(type) {
    pageJump({ name: type === 'information' ? 'information' : 'notice' });
}

const data = reactive({
    newsList: [], // 新闻咨询列表
    noticeList: [], // 通知公告列表数据
});

// 应用类型对应
const instAppTypeMap = {
    topic: '1', // 专题
    lesson: '2', // 同步备课
    banner: '3', // banner
    notice: '4', // 通知公告
    information: '5', // 新闻资讯
    expert_team: '6', // 专家团队
    monitor: '7', // 测评
    cooperateOrg: '8', // 合作机构
    quick: '9', // 快捷入口
    yanxiu_star: '10', // 研修之星
    portal: '11', // 门户
};

// 排序类型对应
const orderTypeMap = {
    notice: 'recommend',
    information: 'recommend',
};

// 获取banner/新闻咨询/通知公告/快捷入口数据
const getFirstScreenContent = async type => {
    let params = getRequesetParams(type);
    let obj = await getStages(portalTemplate?.value?.ruleKey == 3);
    G_transmit('getFirstScreenContent', {
        name: 'getFirstScreenContent',
        queries: {
            ...params,
            ...obj,
        },
    }).then(res => {
        let result = res?.data?.rows || [];
        result.forEach(item => {
            item.publishTime = dayjs(item.publishTime).format('YYYY.MM.DD');
        });
        switch (type) {
            case 'information':
                data.newsList = result;
                break;
            case 'notice':
                data.noticeList = result;
                break;
        }
    });
};

function getRequesetParams(type) {
    let params = {};
    switch (type) {
        case 'information': {
            params = {
                instAppTypeId: instAppTypeMap[type],
                pageIndex: 1,
                pageSize: 5,
                orderType: orderTypeMap[type],
                publishPlace: 'PC',
                publishState: 1, // 发布状态
            };
            break;
        }
        case 'notice': {
            params = {
                instAppTypeId: instAppTypeMap[type],
                pageIndex: 1,
                pageSize: 5,
                orderType: orderTypeMap[type],
                publishPlace: 'PC',
                publishState: 1, // 发布状态
            };
            break;
        }
    }
    return params;
}

watch(
    () => portalTemplate,
    newTemp => {
        if (newTemp?.value?.ruleKey) {
            // getFirstScreenContent();
            // 获取新闻咨询数据
            getFirstScreenContent('information');
            // 获取通知公告数据
            getFirstScreenContent('notice');
        }
    },
    {
        deep: true,
        immediate: true,
    },
);

onMounted(() => {
    /* // 获取新闻咨询数据
    getFirstScreenContent('information');
    // 获取通知公告数据
    getFirstScreenContent('notice'); */
});
</script>

<style lang="scss" scoped>
.news-shortcut-container {
    width: 1200px;
    margin: 30px auto 0;
    height: 324px;
    display: flex;
    justify-content: flex-start;
    justify-content: space-between;
    background-color: #ffffff;
    .left-wrap {
        width: 799px;
        margin-top: 10px;
        box-sizing: border-box;
    }
    .right-wrap {
        width: 360px;
        background: linear-gradient(
            360deg,
            rgba(240, 247, 255, 0.71) 0%,
            rgba(238, 246, 255, 0.34) 100%
        );
        border-radius: 4px;
        padding: 20px;
    }
    .common-header-wrap {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .name {
            flex: 1;
            font-size: 20px;
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            font-weight: bold;
            color: var(--srt-main-text-color);
            line-height: 26px;
        }
        .more {
            width: 40px;
            display: flex;
            align-items: center;
            line-height: 19px;
            color: var(--srt-color-gray);
            &::after {
                content: '';
                width: 10px;
                height: 10px;
                background-image: url(~@/assets/img/gateway/more-icon@2x.png);
                background-size: 10px 10px;
                margin-left: 2px;
            }
            &:hover {
                color: var(--srt-main-active-text-color);
                cursor: pointer;
                &::after {
                    background-image: url(~@/assets/img/gateway/more-icon-active@2x.png);
                }
            }
        }
    }
}
</style>
